import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SkillLevelsService } from 'src/app/services/skilllevels.service';
import { SkillLevelsModalComponent } from './skilllevels-modal/skilllevels-modal.component';
import { SearchFilterComponent } from '../../shared/search-filter/search-filter.component';
import { PaginationComponent } from '../../shared/pagination/pagination.component';

@Component({
  selector: 'app-skilllevels',
  imports: [CommonModule, SearchFilterComponent, PaginationComponent],
  templateUrl: './skilllevels.component.html',
  styleUrl: './skilllevels.component.css'
})
export class SkillLevelsComponent implements OnInit {
  
  SkillLevelsList: any[] = [];
  filteredData: any[] = [];
  pagedData: any[] = [];
  pageSize: number = 10;

  constructor(
      private dialog: MatDialog,
      private SkillLevelsService: SkillLevelsService,
      private changeDetectorRef: ChangeDetectorRef
    ) {} 

  ngOnInit(): void {
      this.getSkillLevels();
  }

  getSkillLevels(){
    this.SkillLevelsService.getSkillLevels().subscribe({
      next: (res: any) => {
        this.SkillLevelsList = res;
        this.filteredData = res;
        this.changeDetectorRef.detectChanges();
      },
      error: (err: any) => {
        console.error('Error al cargar niveles de habilidad:', err);
        this.pagedData = [];
      }
    });
  }

  onPageSizeChange(newSize: number) {
    this.pageSize = newSize;
  }

  openModal(item: any, mode: any, title: any) {
    const dialogRef = this.dialog.open(SkillLevelsModalComponent, {
      data: { item, mode, title },
      maxWidth: '100%',
      width: '40%',
    });
    dialogRef.afterClosed().subscribe({
      next: (res: any) => {
        if (!res) return
        if (res) {
          this.getSkillLevels();
        }
      }
    });
  }
}
